import { Injectable } from '@angular/core';
import { AbstractControl, FormGroupDirective, NgForm } from '@angular/forms';
import { ShowOnDirtyErrorStateMatcher } from '@angular/material/core';

@Injectable()
export class ErrorStateMatcher extends ShowOnDirtyErrorStateMatcher {
  private static instance: ErrorStateMatcher;

  public static showAlwaysIfPresent: boolean = false;

  public static getInstance(): ErrorStateMatcher {
    return ErrorStateMatcher.instance ?? (ErrorStateMatcher.instance = new ErrorStateMatcher());
  }

  public override isErrorState(control: AbstractControl | null, form: FormGroupDirective | NgForm | null): boolean {
    return control?.touched && super.isErrorState(control, form)
      || ErrorStateMatcher.showAlwaysIfPresent && Boolean(control?.errors);
  }
}
